/*
 * Rx cart sync
 * ------------
 * An Rx job is a frame line plus linked lens/add-on lines sharing the same `_rx_group` property (see
 * rx-lens-selector.js). This keeps every linked line at the frame's quantity, and removes linked lines whose frame
 * was removed, whenever the cart changes.
 */
(() => {
  if (window.__rxCartSync) {
    return;
  }
  window.__rxCartSync = true;

  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  let syncing = false;

  const fetchCart = async () => (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();

  // Returns { lineKey: quantity } for every linked line that is out of sync with its frame.
  const computeUpdates = (cart) => {
    const frames = {};
    cart.items.forEach((item) => {
      const properties = item.properties || {};
      if (properties._rx_group && properties._rx_role === 'frame') {
        frames[properties._rx_group] = (frames[properties._rx_group] || 0) + item.quantity;
      }
    });

    const updates = {};
    cart.items.forEach((item) => {
      const properties = item.properties || {};
      if (!properties._rx_group || properties._rx_role === 'frame') {
        return;
      }
      const target = frames[properties._rx_group] || 0;
      if (item.quantity !== target) {
        updates[item.key] = target;
      }
    });
    return updates;
  };

  const sync = async (cart) => {
    if (syncing) {
      return;
    }
    syncing = true;
    try {
      const updates = computeUpdates(cart || await fetchCart());
      if (!Object.keys(updates).length) {
        return;
      }
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (error) {
      console.error('Rx cart sync failed', error);
    } finally {
      syncing = false;
    }
  };

  document.addEventListener('cart:change', (event) => sync(event.detail?.cart));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sync());
  } else {
    sync();
  }
})();
